import { REQUEST_UPDATE_ACCOUNT_ADDRESS, RECEIVE_UPDATE_ACCOUNT_ADDRESS } from '../../../ActionsConst';

export const requestUpdateAccountAddress = (companyAddress) => ({
  type: REQUEST_UPDATE_ACCOUNT_ADDRESS,
  companyAddress,
});

export const receiveUpdateAccountAddress = (isSuccessful: boolean) => ({
  type: RECEIVE_UPDATE_ACCOUNT_ADDRESS,
  isSuccessful,
});
